module.exports = __webpack_public_path__ + "static/media/jezael-melgoza-975446-unsplash.7f4e64ee.jpg";